export const getCurrentPathnameAndQueryParams = location => `${location.pathname}${location.search}`;